// @ts-nocheck
import Button from 'components/base/Button';
import DatePicker from 'components/base/DatePicker';
import ReactSelect from 'components/base/ReactSelect';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { defaultBreadcrumbItems } from 'data/commonData';
import { Badge, Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { getCookie, isAuth } from 'helpers/helpers';

const CreateNew = () => {
  let navigate = useNavigate();
  const [hauptkategorie, setHauptkategorie] = useState('');
  const [productId, setProductId] = useState('');
  const [mainBildURL, setMainBildURL] = useState('');
  const [productUpdated, setProductUpdated] = useState(true);
  const [imageUrl, setImageUrl] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [product, setProduct] = useState('');
  const [produktTitel, setProduktTitel] = useState('');
  const [PlentyKategorieID, setPlentyKategorieID] = useState('');
  const [bildnummer, setBildnummer] = useState('');
  const [ean, setEan] = useState('');
  const [oldEAN, setOldEAN] = useState('');
  const [motiv, setMotiv] = useState('');
  const [eigeneSKU, setEigeneSKU] = useState('');
  const [fotobel_SKU, setFotobel_SKU] = useState('');
  const [anzahl_Varianten, setAnzahl_Varianten] = useState('');
  const [variantennummer, setVariantennummer] = useState('');
  const [variantenbezeichnung, setVariantenbezeichnung] = useState('');
  const [motivname, setMotivname] = useState('');
  const [motivnameCount, setMotivnameCount] = useState('');
  const [number, setNumber] = useState('');
  const [farbe, setFarbe] = useState('');
  const [marke, setMarke] = useState('');
  const [anzahl, setAnzahl] = useState('');
  const [masseinheit, setMasseinheit] = useState('');
  const [konsumentenEinheit, setKonsumentenEinheit] = useState('');
  const [produktebene, setProduktebene] = useState('');
  const [onlineKatalog, setOnlineKatalog] = useState('');
  const [GEPIR, setGEPIR] = useState('');
  const [zielmarkt, setZielmarkt] = useState('');
  const [waehrung, setWaehrung] = useState('');
  const [produktname, setProduktname] = useState('');
  const [name_EAN, setName_EAN] = useState('');
  const [kaufland, setKaufland] = useState('');
  const [OTTO, setOTTO] = useState('');
  const [shopify, setShopify] = useState('');
  const [keywords, setKeywords] = useState('');

  const [Tueroeffnung_Links_FRONT, setTueroeffnung_Links_FRONT] = useState('');
  const [Tueroeffnung_Links_HALF, setTueroeffnung_Links_HALF] = useState('');
  const [Tueroeffnung_Links_HINTEN, setTueroeffnung_Links_HINTEN] =
    useState('');
  const [Tueroeffnung_Links_MAGNET, setTueroeffnung_Links_MAGNET] =
    useState('');
  const [Tueroeffnung_Links_OBEN, setTueroeffnung_Links_OBEN] = useState('');
  const [Tueroeffnung_Links_OFFEN, setTueroeffnung_Links_OFFEN] = useState('');
  const [Tueroeffnung_Links_WAND, setTueroeffnung_Links_WAND] = useState('');
  const [Tueroeffnung_Rechts_FRONT, setTueroeffnung_Rechts_FRONT] =
    useState('');
  const [Tueroeffnung_Rechts_HALF, setTueroeffnung_Rechts_HALF] = useState('');
  const [Tueroeffnung_Rechts_HINTEN, setTueroeffnung_Rechts_HINTEN] =
    useState('');
  const [Tueroeffnung_Rechts_MAGNET, setTueroeffnung_Rechts_MAGNET] =
    useState('');
  const [Tueroeffnung_Rechts_OBEN, setTueroeffnung_Rechts_OBEN] = useState('');
  const [Tueroeffnung_Rechts_OFFEN, setTueroeffnung_Rechts_OFFEN] =
    useState('');
  const [Tueroeffnung_Rechts_WAND, setTueroeffnung_Rechts_WAND] = useState('');

  useEffect(() => {
    const productEAN = searchParams.get('ean');
    if (!isAuth()) {
    } else {
      const token = getCookie('token');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/receive-one-product',
        data: { ean: productEAN },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          setMainBildURL(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Bild_URL
              ? response.data.oneProduct.ean_gtins[0].Bild_URL
              : ''
          );

          setProductId(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.id
              ? response.data.oneProduct.id
              : ''
          );

          setHauptkategorie(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Hauptkategorie
              ? response.data.oneProduct.Hauptkategorie
              : ''
          );

          setTueroeffnung_Links_FRONT(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Links_FRONT
              ? response.data.oneProduct.datens[0].Tueroeffnung_Links_FRONT
              : ''
          );
          setTueroeffnung_Links_HALF(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Links_HALF
              ? response.data.oneProduct.datens[0].Tueroeffnung_Links_HALF
              : ''
          );
          setTueroeffnung_Links_HINTEN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Links_HINTEN
              ? response.data.oneProduct.datens[0].Tueroeffnung_Links_HINTEN
              : ''
          );
          setTueroeffnung_Links_MAGNET(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Links_MAGNET
              ? response.data.oneProduct.datens[0].Tueroeffnung_Links_MAGNET
              : ''
          );
          setTueroeffnung_Links_OBEN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Links_OBEN
              ? response.data.oneProduct.datens[0].Tueroeffnung_Links_OBEN
              : ''
          );
          setTueroeffnung_Links_OFFEN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Links_OFFEN
              ? response.data.oneProduct.datens[0].Tueroeffnung_Links_OFFEN
              : ''
          );
          setTueroeffnung_Links_WAND(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Links_WAND
              ? response.data.oneProduct.datens[0].Tueroeffnung_Links_WAND
              : ''
          );
          setTueroeffnung_Rechts_FRONT(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Rechts_FRONT
              ? response.data.oneProduct.datens[0].Tueroeffnung_Rechts_FRONT
              : ''
          );
          setTueroeffnung_Rechts_HALF(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Rechts_HALF
              ? response.data.oneProduct.datens[0].Tueroeffnung_Rechts_HALF
              : ''
          );
          setTueroeffnung_Rechts_HINTEN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Rechts_HINTEN
              ? response.data.oneProduct.datens[0].Tueroeffnung_Rechts_HINTEN
              : ''
          );
          setTueroeffnung_Rechts_MAGNET(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Rechts_MAGNET
              ? response.data.oneProduct.datens[0].Tueroeffnung_Rechts_MAGNET
              : ''
          );
          setTueroeffnung_Rechts_OBEN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Rechts_OBEN
              ? response.data.oneProduct.datens[0].Tueroeffnung_Rechts_OBEN
              : ''
          );
          setTueroeffnung_Rechts_OFFEN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Rechts_OFFEN
              ? response.data.oneProduct.datens[0].Tueroeffnung_Rechts_OFFEN
              : ''
          );
          setTueroeffnung_Rechts_WAND(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Tueroeffnung_Rechts_WAND
              ? response.data.oneProduct.datens[0].Tueroeffnung_Rechts_WAND
              : ''
          );

          setImageUrl(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Bild_URL
              ? response.data.oneProduct.ean_gtins[0].Bild_URL
              : ''
          );

          setProduktTitel(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Titel_Deutsch
              ? response.data.oneProduct.Titel_Deutsch
              : ''
          );

          setPlentyKategorieID(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Plenty_Kategorie_ID
              ? response.data.oneProduct.datens[0].Plenty_Kategorie_ID
              : ''
          );

          setBildnummer(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Bildnummer
              ? response.data.oneProduct.Bildnummer
              : ''
          );

          setOldEAN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.EAN
              ? response.data.oneProduct.EAN
              : ''
          );

          setEan(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.EAN
              ? response.data.oneProduct.EAN
              : ''
          );

          setMotiv(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Motiv
              ? response.data.oneProduct.Motiv
              : ''
          );

          setEigeneSKU(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Eigene_SKU
              ? response.data.oneProduct.Eigene_SKU
              : ''
          );

          setFotobel_SKU(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Fotobel_SKU
              ? response.data.oneProduct.Fotobel_SKU
              : ''
          );

          setAnzahl_Varianten(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Anzahl_Varianten
              ? response.data.oneProduct.Anzahl_Varianten
              : ''
          );

          setVariantennummer(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Variantennummer
              ? response.data.oneProduct.Variantennummer
              : ''
          );

          setVariantenbezeichnung(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Variantenbezeichnung
              ? response.data.oneProduct.Variantenbezeichnung
              : ''
          );

          setMotivname(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Motivname
              ? response.data.oneProduct.datens[0].Motivname
              : ''
          );

          setMotivnameCount(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Motivname_Count
              ? response.data.oneProduct.datens[0].Motivname_Count
              : ''
          );

          setNumber(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Number
              ? response.data.oneProduct.datens[0].Number
              : ''
          );

          setFarbe(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Farbe
              ? response.data.oneProduct.Farbe
              : ''
          );

          setMarke(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Marke
              ? response.data.oneProduct.ean_gtins[0].Marke
              : ''
          );

          setAnzahl(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.Anzahl_Deutsch
              ? response.data.oneProduct.Anzahl_Deutsch
              : ''
          );

          setMasseinheit(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0]
                .Masseinheit_Nettofuellmenge_1
              ? response.data.oneProduct.ean_gtins[0]
                  .Masseinheit_Nettofuellmenge_1
              : ''
          );

          setKonsumentenEinheit(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Konsumenten_Einheit
              ? response.data.oneProduct.ean_gtins[0].Konsumenten_Einheit
              : ''
          );

          setProduktebene(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Produktebene
              ? response.data.oneProduct.ean_gtins[0].Produktebene
              : ''
          );

          setOnlineKatalog(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0]
                .Veroeffentlichung_im_Online_Katalog
              ? response.data.oneProduct.ean_gtins[0]
                  .Veroeffentlichung_im_Online_Katalog
              : ''
          );

          setGEPIR(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Veroeffentlichung_in_GEPIR
              ? response.data.oneProduct.ean_gtins[0].Veroeffentlichung_in_GEPIR
              : ''
          );

          setZielmarkt(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Zielmarkt_Verkaufsland_1
              ? response.data.oneProduct.ean_gtins[0].Zielmarkt_Verkaufsland_1
              : ''
          );

          setWaehrung(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Waehrung
              ? response.data.oneProduct.ean_gtins[0].Waehrung
              : ''
          );

          setProduktname(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.ean_gtins &&
              response.data.oneProduct.ean_gtins[0] &&
              response.data.oneProduct.ean_gtins[0].Produktname
              ? response.data.oneProduct.ean_gtins[0].Produktname
              : ''
          );

          setName_EAN(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Name_EAN
              ? response.data.oneProduct.datens[0].Name_EAN
              : ''
          );

          setKaufland(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Name_Kaufland_DE
              ? response.data.oneProduct.datens[0].Name_Kaufland_DE
              : ''
          );

          setOTTO(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Name_OTTO_DE
              ? response.data.oneProduct.datens[0].Name_OTTO_DE
              : ''
          );

          setShopify(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Name_Shopify
              ? response.data.oneProduct.datens[0].Name_Shopify
              : ''
          );

          setKeywords(
            response &&
              response.data &&
              response.data.oneProduct &&
              response.data.oneProduct.datens &&
              response.data.oneProduct.datens[0] &&
              response.data.oneProduct.datens[0].Real_Keywords
              ? response.data.oneProduct.datens[0].Real_Keywords
              : ''
          );

          setProduct(response.data.oneProduct);
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  }, [searchParams]);

  const updateValuesOnServer = () => {
    const productEAN = searchParams.get('ean');
    if (!isAuth()) {
    } else {
      const token = getCookie('token');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/update-product',
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
          mainBildURL,
          productId,
          produktTitel,
          PlentyKategorieID,
          bildnummer,
          ean,
          motiv,
          eigeneSKU,
          fotobel_SKU,
          anzahl_Varianten,
          variantennummer,
          variantenbezeichnung,
          motivname,
          motivnameCount,
          number,
          farbe,
          marke,
          anzahl,
          masseinheit,
          konsumentenEinheit,
          produktebene,
          onlineKatalog,
          GEPIR,
          zielmarkt,
          waehrung,
          produktname,
          name_EAN,
          kaufland,
          OTTO,
          shopify,
          keywords,
          hauptkategorie,
          Tueroeffnung_Rechts_FRONT,
          Tueroeffnung_Rechts_HALF,
          Tueroeffnung_Rechts_MAGNET,
          Tueroeffnung_Rechts_OFFEN,
          Tueroeffnung_Rechts_OBEN,
          Tueroeffnung_Rechts_WAND,
          Tueroeffnung_Rechts_HINTEN,
          Tueroeffnung_Links_FRONT,
          Tueroeffnung_Links_HALF,
          Tueroeffnung_Links_MAGNET,
          Tueroeffnung_Links_OFFEN,
          Tueroeffnung_Links_OBEN,
          Tueroeffnung_Links_WAND,
          Tueroeffnung_Links_HINTEN
        }
      })
        .then(response => {
          if (response.status == '200') {
            toast.success('Aktualisierung erfolgreich', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          } else if (response.status == '201') {
            toast.success('Neues Produkt erfolgreich erstellt', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
            setTimeout(() => {
              navigate(`/primedeco/product-table?s=${produktTitel}`);
            }, 3000);
          } else {
            toast.error('Es ist ein Fehler aufgetreten', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          }
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  };

  useEffect(() => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/check-if-ean-exists',
        data: { ean },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        if (response.status == '200') {
          setProductUpdated(true);
        } else {
          setProductUpdated(false);
        }
      });
    }
  }, [ean]);

  const changeValues = (identifier, e) => {
    if (identifier == 'produktTitel') {
      setProduktTitel(e.target.value);
    } else if (identifier == 'Hauptkategorie') {
      setHauptkategorie(e.target.value);
    } else if (identifier == 'PlentyKategorieID') {
      setPlentyKategorieID(e.target.value);
    } else if (identifier == 'bildnummer') {
      setBildnummer(e.target.value);
    } else if (identifier == 'ean') {
      setEan(e.target.value);
    } else if (identifier == 'motiv') {
      setMotiv(e.target.value);
    } else if (identifier == 'eigeneSKU') {
      setEigeneSKU(e.target.value);
    } else if (identifier == 'fotobel_SKU') {
      setFotobel_SKU(e.target.value);
    } else if (identifier == 'anzahl_Varianten') {
      setAnzahl_Varianten(e.target.value);
    } else if (identifier == 'variantennummer') {
      setVariantennummer(e.target.value);
    } else if (identifier == 'variantenbezeichnung') {
      setVariantenbezeichnung(e.target.value);
    } else if (identifier == 'motivname') {
      setMotivname(e.target.value);
    } else if (identifier == 'motivnameCount') {
      setMotivnameCount(e.target.value);
    } else if (identifier == 'number') {
      setNumber(e.target.value);
    } else if (identifier == 'farbe') {
      setFarbe(e.target.value);
    } else if (identifier == 'marke') {
      setMarke(e.target.value);
    } else if (identifier == 'anzahl') {
      setAnzahl(e.target.value);
    } else if (identifier == 'masseinheit') {
      setMasseinheit(e.target.value);
    } else if (identifier == 'konsumentenEinheit') {
      setKonsumentenEinheit(e.target.value);
    } else if (identifier == 'produktebene') {
      setProduktebene(e.target.value);
    } else if (identifier == 'onlineKatalog') {
      setOnlineKatalog(e.target.value);
    } else if (identifier == 'GEPIR') {
      setGEPIR(e.target.value);
    } else if (identifier == 'zielmarkt') {
      setZielmarkt(e.target.value);
    } else if (identifier == 'waehrung') {
      setWaehrung(e.target.value);
    } else if (identifier == 'produktname') {
      setProduktname(e.target.value);
    } else if (identifier == 'name_EAN') {
      setName_EAN(e.target.value);
    } else if (identifier == 'kaufland') {
      setKaufland(e.target.value);
    } else if (identifier == 'OTTO') {
      setOTTO(e.target.value);
    } else if (identifier == 'shopify') {
      setShopify(e.target.value);
    } else if (identifier == 'keywords') {
      setKeywords(e.target.value);
    } else if (identifier == 'Bild_URL') {
      setMainBildURL(e.target.value);
    } else if (identifier == 'Tueroeffnung_Rechts_FRONT') {
      setTueroeffnung_Rechts_FRONT(e.target.value);
    } else if (identifier == 'Tueroeffnung_Rechts_HALF') {
      setTueroeffnung_Rechts_HALF(e.target.value);
    } else if (identifier == 'Tueroeffnung_Rechts_MAGNET') {
      setTueroeffnung_Rechts_MAGNET(e.target.value);
    } else if (identifier == 'Tueroeffnung_Rechts_OFFEN') {
      setTueroeffnung_Rechts_OFFEN(e.target.value);
    } else if (identifier == 'Tueroeffnung_Rechts_OBEN') {
      setTueroeffnung_Rechts_OBEN(e.target.value);
    } else if (identifier == 'Tueroeffnung_Rechts_WAND') {
      setTueroeffnung_Rechts_WAND(e.target.value);
    } else if (identifier == 'Tueroeffnung_Rechts_HINTEN') {
      setTueroeffnung_Rechts_HINTEN(e.target.value);
    } else if (identifier == 'Tueroeffnung_Links_FRONT') {
      setTueroeffnung_Links_FRONT(e.target.value);
    } else if (identifier == 'Tueroeffnung_Links_HALF') {
      setTueroeffnung_Links_HALF(e.target.value);
    } else if (identifier == 'Tueroeffnung_Links_MAGNET') {
      setTueroeffnung_Links_MAGNET(e.target.value);
    } else if (identifier == 'Tueroeffnung_Links_OFFEN') {
      setTueroeffnung_Links_OFFEN(e.target.value);
    } else if (identifier == 'Tueroeffnung_Links_OBEN') {
      setTueroeffnung_Links_OBEN(e.target.value);
    } else if (identifier == 'Tueroeffnung_Links_WAND') {
      setTueroeffnung_Links_WAND(e.target.value);
    } else if (identifier == 'Tueroeffnung_Links_HINTEN') {
      setTueroeffnung_Links_HINTEN(e.target.value);
    }
  };

  const changeEANtoStart = () => {
    setEan(oldEAN);
  };

  return (
    <div>
      <PageBreadcrumb items={defaultBreadcrumbItems} />
      <ToastContainer />
      {productUpdated ? (
        <h2 className="mb-4 text-primary" style={{ marginTop: '-60px' }}>
          Produkt wird aktualisiert
        </h2>
      ) : (
        <>
          <h2
            className="mb-4 text-warning"
            style={{
              marginTop: '-60px'
            }}
          >
            Produkt wird neu erstellt
          </h2>
          <div
            style={{
              cursor: 'pointer',
              fontSize: '20px',
              marginBottom: '20px'
            }}
            onClick={() => changeEANtoStart()}
          >
            <Badge bg="danger">EAN wiederherstellen</Badge>
          </div>
        </>
      )}

      <Row>
        <Col xs={12} xl={9}>
          <Row as="form" className="g-3 mb-6">
            <Col sm={6} md={8} style={{ paddingRight: '50px' }}>
              <FloatingLabel label="EAN - Primärer Identifikator">
                <Form.Control
                  style={productUpdated ? { color: 'green' } : { color: 'red' }}
                  type="text"
                  placeholder="EAN"
                  value={ean && ean}
                  onChange={e => changeValues('ean', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Produkttitel">
                <Form.Control
                  type="text"
                  placeholder="Titel"
                  value={produktTitel && produktTitel}
                  onChange={e => changeValues('produktTitel', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Plenty Kategorie ID">
                <Form.Control
                  type="text"
                  placeholder="Plenty Kategorie ID"
                  value={PlentyKategorieID && PlentyKategorieID}
                  onChange={e => changeValues('PlentyKategorieID', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Bildnummer">
                <Form.Control
                  type="text"
                  placeholder="Bildnummer"
                  value={bildnummer && bildnummer}
                  onChange={e => changeValues('bildnummer', e)}
                />
              </FloatingLabel>

              <br />
              <FloatingLabel label="Motiv">
                <Form.Control
                  type="text"
                  placeholder="Motiv"
                  value={motiv && motiv}
                  onChange={e => changeValues('motiv', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Eigene SKU">
                <Form.Control
                  type="text"
                  placeholder="Eigene SKU"
                  value={eigeneSKU && eigeneSKU}
                  onChange={e => changeValues('eigeneSKU', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Fotobel SKU">
                <Form.Control
                  type="text"
                  placeholder="Fotobel SKU"
                  value={fotobel_SKU && fotobel_SKU}
                  onChange={e => changeValues('fotobel_SKU', e)}
                />
              </FloatingLabel>
              <br />
              <br />
              <h5>Varianten</h5>
              <br />
              <FloatingLabel label="Anzahl Varianten">
                <Form.Control
                  type="text"
                  placeholder="anzahl_Varianten SKU"
                  value={anzahl_Varianten && anzahl_Varianten}
                  onChange={e => changeValues('anzahl_Varianten', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Variantennummer">
                <Form.Control
                  type="text"
                  placeholder="Variantennummer"
                  value={variantennummer && variantennummer}
                  onChange={e =>
                    changeValues('variantennummer', varianetennummer)
                  }
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Variantenbezeichnung">
                <Form.Control
                  type="text"
                  placeholder="Variantenbezeichnung"
                  value={variantenbezeichnung && variantenbezeichnung}
                  onChange={e => changeValues('variantenbezeichnung', e)}
                />
              </FloatingLabel>
              <br />
              <br />
              <h5>Eigenschaften</h5>
              <br />
              <FloatingLabel label="Hauptkategorie">
                <Form.Control
                  type="text"
                  placeholder="Hauptkategorie"
                  value={hauptkategorie && hauptkategorie}
                  onChange={e => changeValues('Hauptkategorie', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Motivname">
                <Form.Control
                  type="text"
                  placeholder="Motivname"
                  value={motivname && motivname}
                  onChange={e => changeValues('motivname', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Motivname Count">
                <Form.Control
                  type="text"
                  placeholder="Motivname Count"
                  value={motivnameCount && motivnameCount}
                  onChange={e => changeValues('motivnameCount', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Number">
                <Form.Control
                  type="text"
                  placeholder="Number"
                  value={number && number}
                  onChange={e => changeValues('number', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Farbe">
                <Form.Control
                  type="text"
                  placeholder="Farbe"
                  value={farbe && farbe}
                  onChange={e => changeValues('farbe', e)}
                />
              </FloatingLabel>
              <br />
              <br />
              <h5>Lager</h5>
              <br />

              <FloatingLabel label="Marke">
                <Form.Control
                  type="text"
                  placeholder="Marke"
                  value={marke && marke}
                  onChange={e => changeValues('marke', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Anzahl">
                <Form.Control
                  type="text"
                  placeholder="Anzahl"
                  value={anzahl && anzahl}
                  onChange={e => changeValues('anzahl', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Masseinheit">
                <Form.Control
                  type="text"
                  placeholder="Masseinheit"
                  value={masseinheit && masseinheit}
                  onChange={e => changeValues('masseinheit', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Konsumenten Einheit">
                <Form.Control
                  type="text"
                  placeholder="Konsumenten Einheit"
                  value={konsumentenEinheit && konsumentenEinheit}
                  onChange={e => changeValues('konsumentenEinheit', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Produktebene">
                <Form.Control
                  type="text"
                  placeholder="Produktebene"
                  value={produktebene && produktebene}
                  onChange={e => changeValues('produktebene', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Online Katalog">
                <Form.Control
                  type="text"
                  placeholder="Online Katalog"
                  value={onlineKatalog && onlineKatalog}
                  onChange={e => changeValues('onlineKatalog', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="GEPIR">
                <Form.Control
                  type="text"
                  placeholder="GEPIR"
                  value={GEPIR && GEPIR}
                  onChange={e => changeValues('GEPIR', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Zielmarkt Verkaufsland 1">
                <Form.Control
                  type="text"
                  placeholder="Zielmarkt Verkaufsland 1"
                  value={zielmarkt && zielmarkt}
                  onChange={e => changeValues('zielmarkt', e)}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Währung">
                <Form.Control
                  type="text"
                  placeholder="Währung"
                  value={waehrung && waehrung}
                  onChange={e => changeValues('waehrung', e)}
                />
              </FloatingLabel>
              <br />
              <br />
              <h5>Texte</h5>
              <br />

              <FloatingLabel label="Produktname">
                <Form.Control
                  placeholder="Produktname"
                  value={produktname && produktname}
                  onChange={e => changeValues('produktname', e)}
                  style={{ height: '70px' }}
                  as="textarea"
                  rows={2}
                />
              </FloatingLabel>

              <br />
              <FloatingLabel label="Name EAN">
                <Form.Control
                  style={{ height: '70px' }}
                  as="textarea"
                  rows={2}
                  placeholder="Name EAN"
                  value={name_EAN && name_EAN}
                  onChange={e => changeValues('name_EAN', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Kaufland">
                <Form.Control
                  style={{ height: '70px' }}
                  as="textarea"
                  rows={2}
                  placeholder="Kaufland"
                  value={kaufland && kaufland}
                  onChange={e => changeValues('kaufland', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="OTTO">
                <Form.Control
                  style={{ height: '70px' }}
                  as="textarea"
                  rows={2}
                  placeholder="OTTO"
                  value={OTTO && OTTO}
                  onChange={e => changeValues('OTTO', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Shopify">
                <Form.Control
                  style={{ height: '70px' }}
                  as="textarea"
                  rows={2}
                  placeholder="Shopify"
                  value={shopify && shopify}
                  onChange={e => changeValues('shopify', e)}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Keywords">
                <Form.Control
                  style={{ height: '70px' }}
                  as="textarea"
                  rows={2}
                  placeholder="Keywords"
                  value={keywords && keywords}
                  onChange={e => changeValues('keywords', e)}
                />
              </FloatingLabel>
              <br />
              <br />
              <h5>Bilder</h5>
              <br />
              <FloatingLabel label="Bild_URL">
                <Form.Control
                  placeholder="Bild_URL"
                  value={mainBildURL && mainBildURL}
                  onChange={e => changeValues('Bild_URL', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Tueroeffnung_Rechts_FRONT">
                <Form.Control
                  placeholder="Tueroeffnung_Rechts_FRONT"
                  value={Tueroeffnung_Rechts_FRONT && Tueroeffnung_Rechts_FRONT}
                  onChange={e => changeValues('Tueroeffnung_Rechts_FRONT', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Tueroeffnung_Rechts_HALF">
                <Form.Control
                  placeholder="Tueroeffnung_Rechts_HALF"
                  value={Tueroeffnung_Rechts_HALF && Tueroeffnung_Rechts_HALF}
                  onChange={e => changeValues('Tueroeffnung_Rechts_HALF', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />
              <FloatingLabel label="Tueroeffnung_Rechts_MAGNET">
                <Form.Control
                  placeholder="Tueroeffnung_Rechts_MAGNET"
                  value={
                    Tueroeffnung_Rechts_MAGNET && Tueroeffnung_Rechts_MAGNET
                  }
                  onChange={e => changeValues('Tueroeffnung_Rechts_MAGNET', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Rechts_OFFEN">
                <Form.Control
                  placeholder="Tueroeffnung_Rechts_OFFEN"
                  value={Tueroeffnung_Rechts_OFFEN && Tueroeffnung_Rechts_OFFEN}
                  onChange={e => changeValues('Tueroeffnung_Rechts_OFFEN', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Rechts_OBEN">
                <Form.Control
                  placeholder="Tueroeffnung_Rechts_OBEN"
                  value={Tueroeffnung_Rechts_OBEN && Tueroeffnung_Rechts_OBEN}
                  onChange={e => changeValues('Tueroeffnung_Rechts_OBEN', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Rechts_WAND">
                <Form.Control
                  placeholder="Tueroeffnung_Rechts_WAND"
                  value={Tueroeffnung_Rechts_WAND && Tueroeffnung_Rechts_WAND}
                  onChange={e => changeValues('Tueroeffnung_Rechts_WAND', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Rechts_HINTEN">
                <Form.Control
                  placeholder="Tueroeffnung_Rechts_HINTEN"
                  value={
                    Tueroeffnung_Rechts_HINTEN && Tueroeffnung_Rechts_HINTEN
                  }
                  onChange={e => changeValues('Tueroeffnung_Rechts_HINTEN', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Links_FRONT">
                <Form.Control
                  placeholder="Tueroeffnung_Links_FRONT"
                  value={Tueroeffnung_Links_FRONT && Tueroeffnung_Links_FRONT}
                  onChange={e => changeValues('Tueroeffnung_Links_FRONT', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Links_HALF">
                <Form.Control
                  placeholder="Tueroeffnung_Links_HALF"
                  value={Tueroeffnung_Links_HALF && Tueroeffnung_Links_HALF}
                  onChange={e => changeValues('Tueroeffnung_Links_HALF', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Links_MAGNET">
                <Form.Control
                  placeholder="Tueroeffnung_Links_MAGNET"
                  value={Tueroeffnung_Links_MAGNET && Tueroeffnung_Links_MAGNET}
                  onChange={e => changeValues('Tueroeffnung_Links_MAGNET', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Links_OFFEN">
                <Form.Control
                  placeholder="Tueroeffnung_Links_OFFEN"
                  value={Tueroeffnung_Links_OFFEN && Tueroeffnung_Links_OFFEN}
                  onChange={e => changeValues('Tueroeffnung_Links_OFFEN', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Links_OBEN">
                <Form.Control
                  placeholder="Tueroeffnung_Links_OBEN"
                  value={Tueroeffnung_Links_OBEN && Tueroeffnung_Links_OBEN}
                  onChange={e => changeValues('Tueroeffnung_Links_OBEN', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Links_WAND">
                <Form.Control
                  placeholder="Tueroeffnung_Links_WAND"
                  value={Tueroeffnung_Links_WAND && Tueroeffnung_Links_WAND}
                  onChange={e => changeValues('Tueroeffnung_Links_WAND', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>
              <br />

              <FloatingLabel label="Tueroeffnung_Links_HINTEN">
                <Form.Control
                  placeholder="Tueroeffnung_Links_HINTEN"
                  value={Tueroeffnung_Links_HINTEN && Tueroeffnung_Links_HINTEN}
                  onChange={e => changeValues('Tueroeffnung_Links_HINTEN', e)}
                  style={{ height: '70px' }}
                />
              </FloatingLabel>

              <br />
              <br />
              <div className="d-flex justify-content-start gap-3">
                <Link
                  to={`/primedeco/product-details?ean=${ean && ean}&category=${
                    product && product.Hauptkategorie && product.Hauptkategorie
                  }`}
                >
                  <Button variant="phoenix-primary" className="px-5">
                    Abbrechen
                  </Button>
                </Link>
                <Button
                  onClick={updateValuesOnServer}
                  variant="primary"
                  className="px-5 px-sm-15"
                >
                  Produkt speichern
                </Button>
              </div>
            </Col>
            <Col xs={12} xl={3}>
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Links_FRONT}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Links_HALF}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Links_HINTEN}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Links_MAGNET}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Links_OBEN}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Links_OFFEN}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Links_WAND}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Rechts_FRONT}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Rechts_HALF}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Rechts_HINTEN}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Rechts_MAGNET}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Rechts_OBEN}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Rechts_OFFEN}
              />

              <br />
              <br />
              <img
                style={{ borderRadius: '30px' }}
                width="300px"
                src={Tueroeffnung_Rechts_WAND}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={12} xl={3}></Col>
      </Row>
    </div>
  );
};

export default CreateNew;
